/**
 * Payment authorization shown when a customer saves a card or bank account.
 * Visible on the customer side (unlike the admin info-circles) and gated by a
 * required acknowledgment. The accepted version is recorded on the saved
 * method (orders.stripe_payment_methods.authorization_version / authorized_at)
 * so consent is attributable. Bump the version if the wording materially
 * changes.
 */

export const PAYMENT_AUTHORIZATION_VERSION = '2026-07-12';

export const PAYMENT_AUTHORIZATION_INTRO =
  'Payments are securely processed by Stripe. Your full card or bank number is encrypted by Stripe and is never stored on our servers.';

export const PAYMENT_AUTHORIZATION_CLAUSES: string[] = [
  'You authorize Brix Beverage / Alameda Point Beverage Group to store this payment method for future use.',
  'You authorize us to charge this method for invoice balances you owe, and — if you turn on automatic payments — for those scheduled payments.',
  'For a bank account (ACH), you authorize electronic debits from that account for the amounts above. You may revoke this authorization for future charges at any time.',
  'A returned or failed payment may incur a $35 returned-payment fee, and past-due balances may accrue a 1.5% per-month late charge.',
  'You can remove this payment method or change your authorization anytime in the portal, or by contacting us.',
];

/** One-line acknowledgment the customer checks to agree. */
export const PAYMENT_AUTHORIZATION_ACK =
  'I authorize Brix Beverage to securely store this payment method and charge it as described above.';
